module.exports = {"420203007":"章山街道","420203400":"冶钢农场","420203402":"西塞山工业园区管委会","420203501":"八泉街道","420203502":"澄月街道","420203503":"牧羊湖街道","420203504":"黄思湾街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420203.json
// module id = 1712
// module chunks = 0